// extracted by extract-css-chunks-webpack-plugin
module.exports = {"vMenu":"vMenu-1u0TUsSj","vSelect":"vSelect-1r41DCJv","vMenuBox":"vMenuBox-23s95yAj","listBox":"listBox-2vX4eld0","vlbackhome":"vlbackhome-1w409kTq"};